/**
 * Stored on `systemSettings/platform.creditPacks[]`.
 * Backend validation lives in `backend/functions/src/credits/creditPacks.ts`.
 */
export type CreditPackRow = {
  id: string;
  credits: number;
  pricePence: number;
  /** Short title shown in dropdowns and summaries */
  label?: string;
  /** Longer copy shown where space allows */
  description?: string;
};

/** Defaults used when Firestore has no custom packs (aligned with Cloud Functions). */
export const DEFAULT_CREDIT_PACK_ROWS: CreditPackRow[] = [
  { id: 'pack_25', credits: 25, pricePence: 1500, label: '25 credits' },
  { id: 'pack_50', credits: 50, pricePence: 2800, label: '50 credits' },
  { id: 'pack_100', credits: 100, pricePence: 5200, label: '100 credits' },
];
